import React from "react";

import OperatorConversionsTable from "./operator-conversion-table";
import PageDomain from "../../domain";
import PageContext from "../../context";
import SummeryConversionTable from "./summery-conversion-table";
import DashboardSectionHeader from "../section-header";

import "./style.css";

const OperatorPackageConversions = ({ rawDataApi }) => {
  const { filterValues } = React.useContext(PageContext);
  const [operatorTableDataset, setOperatorTableDataset] = React.useState([]);
  const [summerizedTableDataset, setSummerizedTableDataset] = React.useState(
    []
  );

  React.useEffect(() => {
    const widgetData = PageDomain.generatePackageWiseConversions({
      rawApiData: rawDataApi,
      pricingTiers: filterValues.pricingTiers,
    });
    setOperatorTableDataset(widgetData);
  }, [filterValues.pricingTiers, rawDataApi]);

  React.useEffect(() => {
    const widgetData = PageDomain.generateOperatorSummeryTable({
      rawApiData: rawDataApi,
    });
    setSummerizedTableDataset(widgetData);
  }, [rawDataApi]);

  return (
    <div className="operator-package-conversions">
      <div className="wiget-area-view">
        <DashboardSectionHeader heading="operator summery overviews" />
        <div className="widget-row-container">
          {summerizedTableDataset.map((tableRow) => (
            <div className="widget-container">
              <SummeryConversionTable data={tableRow} />
            </div>
          ))}
        </div>
      </div>
      <div className="wiget-area-view">
        <DashboardSectionHeader heading="package wise conversions" />
        <div className="widget-row-container">
          {operatorTableDataset.map((tableRow) => (
            <div className="widget-container">
              <OperatorConversionsTable data={tableRow} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(OperatorPackageConversions);
